export enum schoolSelectionActionTypes {
  SELECT_SCHOOL = 'SELECT_SCHOOL',
  RESET_SCHOOL_SELECTION = 'RESET_SCHOOL_SELECTION',
}
